export const PHASES = [
  ["requirement_definition", "要件定義"],
  ["basic_design", "基本設計"],
  ["detailed_design", "詳細設計"],
  ["implementation", "実装"],
  ["integration_test", "結合テスト"],
  ["system_test", "システムテスト"],
  ["maintenance", "保守"],
] as const;

export const ROLE_LABELS: Record<string, string> = {
  engineers: "エンジニア",
  qa: "QA",
  consultants: "コンサルタント",
  pm: "PM",
  cs: "CS",
  designers: "デザイナー",
};
